export const userIsLogged = () => {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    return !!role && !!token && !!userId
}

export const userIsClient = () => {
    const userLogged = userIsLogged()

    if (!userLogged) return false

    return localStorage.getItem("role") === 'Client'
}